import React, { useState } from "react";
import { sendEmail } from "../services/emailService";
import "./Formulario.css";
import logo from "../assets/logo.png";
import { motion } from "framer-motion";

const PesquisaAlunosMatriculados = () => {
    const [respostas, setRespostas] = useState({});
    const [modalOpen, setModalOpen] = useState(false);
    const [step, setStep] = useState(-1);
  
    const perguntas = [
        { label: "Como tem sido sua experiência geral no studio?", name: "experiencia_geral", options: ["Excelente", "Boa", "Regular", "Ruim", "Muito ruim"] },
        { label: "Como você avalia a qualidade dos profissionais do studio?", name: "qualidade_profissionais", options: ["Excelente", "Boa", "Regular", "Ruim", "Muito ruim"] },
        { label: "O atendimento recebido pelos instrutores tem atendido suas expectativas?", name: "atendimento_instrutores", options: ["Sim, estou muito satisfeito(a)", "Sim, mas poderia melhorar", "Não, esperava um atendimento melhor", "Não, estou insatisfeito(a)"] },
        { label: "O que você mais gosta nas aulas e no ambiente do studio?", name: "mais_gosta", type: "textarea" },
        { label: "Existe algo que você acredita que poderia ser melhorado?", name: "melhoria", type: "textarea" },
        { label: "Tem alguma sugestão para que possamos tornar sua experiência ainda melhor?", name: "sugestao", type: "textarea" },
        { label: "Em uma escala de 0 a 10, qual a probabilidade de você recomendar nossos serviços para familiares ou amigos?", name: "recomendacao", type: "scale" }
    ];
  
    const handleChange = (e) => {
      const { name, value } = e.target;
      setRespostas((prev) => ({
        ...prev,
        [name]: value,
      }));
    };
  
    const nextStep = () => {
      if (step < perguntas.length - 1) {
        setStep(step + 1);
      }
    };
  
    const prevStep = () => {
      if (step > 0) {
        setStep(step - 1);
      } else {
        setStep(-1);
      }
    };
  
    const handleSubmit = async (e) => {
      e.preventDefault();
      try {
        const formattedRespostas = Object.entries(respostas)
          .map(([key, value]) => `${key}: ${Array.isArray(value) ? value.join(", ") : value}`)
          .join("\n");
        await sendEmail({ message: formattedRespostas }, "Alunos Matriculados");
        setModalOpen(true);
      } catch (error) {
        alert("Erro ao enviar pesquisa.");
      }
    };
  
    return (
      <div className="page-container">
        <div className="header">
          <img src={logo} alt="Studio Corpo e Alma" className="logo logo-large" />
          <h2 className="header-title">Pesquisa de Satisfação</h2>
        </div>
        <div className="form-container">
          {step === -1 ? (
            <div className="intro-container">
              <h3 className="intro-text">Olá! Queremos sempre oferecer a melhor experiência para você no nosso studio de Pilates. Sua opinião é essencial para que possamos continuar evoluindo. Responda abaixo com sinceridade:</h3>
              <hr />
              <button className="submit-button green-button" onClick={nextStep} style={{ width: '100%'}}>Responder Pesquisa</button>
            </div>
          ) : (
            <motion.div
              key={step}
              initial={{ opacity: 0, x: 100 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -100 }}
              transition={{ duration: 0.5 }}
            >
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label><strong>{perguntas[step]?.label}</strong></label>
                  {perguntas[step]?.type === "scale" ? (
                    <div className="scale-group">
                      {[...Array(11)].map((_, i) => (
                        <button key={i} type="button" className="scale-button" style={{ backgroundColor: `rgb(${255 - i * 25}, ${i * 25}, 0)`, borderRadius: '50%', width: '40px', height: '40px', display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '16px', fontWeight: 'bold', cursor: 'pointer' }} onClick={() => setRespostas({ ...respostas, recomendacao: i })}>{i}</button>
                      ))}
                    </div>
                  ) : perguntas[step]?.type === "textarea" ? (
                    <textarea name={perguntas[step]?.name} onChange={handleChange} className="textarea" value={respostas[perguntas[step]?.name] || ""} />
                  ) : (
                    <div className="radio-group">
                      {perguntas[step]?.options?.map((option, i) => (
                        <label key={i} className="radio-label">
                          <input type="radio" name={perguntas[step]?.name} value={option} checked={respostas[perguntas[step]?.name] === option} onChange={handleChange} />
                          {option}
                        </label>
                      ))}
                    </div>
                  )}
                </div>
                <hr />
                <div className="button-group" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                  {step > 0 ? (
                    <button type="button" className="submit-button gray-button" onClick={prevStep}>
                      Voltar
                    </button>
                  ) : (
                    <div></div>
                  )}
                  <button type={step < perguntas.length - 1 ? "button" : "submit"} className="submit-button green-button" onClick={step < perguntas.length - 1 ? nextStep : undefined}>
                    {step < perguntas.length - 1 ? "Próxima" : "Enviar Pesquisa"}
                  </button>
                </div>
              </form>
              {modalOpen && (
                <div className="modal">
                  <div className="modal-content">
                    <p>Agradecemos por compartilhar sua opinião! Sua satisfação é muito importante para nós. 😊</p>
                    <button onClick={() => setModalOpen(false)} className="close-button">Fechar</button>
                  </div>
                </div>
              )}
            </motion.div>
          )}
        </div>
      </div>
    );
  };
  
  export default PesquisaAlunosMatriculados;
